<template>
  <div class="default-layout" style="min-height: 100vh">
    <nuxt />
    <GlobalLoader />
  </div>
</template>

<script>
import GlobalLoader from '~/components/GlobalLoader'

export default {
  components: {
    GlobalLoader,
  },
}
</script>
